import { VStack } from '@chakra-ui/react';
import * as _ from 'lodash';
import React from 'react';

import { CreditAgreement } from '@finley-technologies/finley-types';

import { BorrowingBaseSummaryCash } from './BorrowingBaseSummaryCash';
import { BorrowingBaseSummaryFacilitySummary } from './BorrowingBaseSummaryFacilitySummary';
import { BorrowingBaseSummaryFinalBorrowingBaseReport } from './BorrowingBaseSummaryFinalBorrowingBaseReport';
import { BorrowingBaseSummaryReceivables } from './BorrowingBaseSummaryReceivables';
import {
  BorrowingBaseSummaryInput,
  BorrowingBaseSummarySections,
  LinkAddressAndLabel,
} from './utils';

type BorrowingBaseSummaryWithAllValuesAndDifferenceProps = {
  sections: BorrowingBaseSummarySections[];
  borrowingBaseReports: BorrowingBaseSummaryInput;
  creditAgreement: CreditAgreement.DomainEntity.CreditAgreementFullArtifact;
  eligibilityLink?: LinkAddressAndLabel;
  concentrationLink?: LinkAddressAndLabel;
};
export const BorrowingBaseSummaryWithAllValuesAndDifference = ({
  sections,
  borrowingBaseReports,
  creditAgreement,
  eligibilityLink,
  concentrationLink,
}: BorrowingBaseSummaryWithAllValuesAndDifferenceProps) => {
  const includesSection = (section: BorrowingBaseSummarySections) =>
    _.includes(sections, section);

  const showComparisonAndDifferenceColumns = true;
  const showValueAndReferenceColumnsOnly = false;

  return (
    <VStack mb="24px" spacing="32px" w="100%">
      {includesSection(BorrowingBaseSummarySections.facilitySummary) && (
        <BorrowingBaseSummaryFacilitySummary
          borrowingBaseReports={borrowingBaseReports}
          showComparisonAndDifferenceColumns={
            showComparisonAndDifferenceColumns
          }
          showValueAndReferenceColumnsOnly={showValueAndReferenceColumnsOnly}
        />
      )}
      {includesSection(BorrowingBaseSummarySections.receivables) && (
        <BorrowingBaseSummaryReceivables
          borrowingBaseReports={borrowingBaseReports}
          creditAgreement={creditAgreement}
          showComparisonAndDifferenceColumns={
            showComparisonAndDifferenceColumns
          }
          showValueAndReferenceColumnsOnly={showValueAndReferenceColumnsOnly}
          eligibilityLink={eligibilityLink}
          concentrationLink={concentrationLink}
        />
      )}
      {includesSection(BorrowingBaseSummarySections.cash) && (
        <BorrowingBaseSummaryCash
          borrowingBaseReports={borrowingBaseReports}
          creditAgreement={creditAgreement}
          showComparisonAndDifferenceColumns={
            showComparisonAndDifferenceColumns
          }
          showValueAndReferenceColumnsOnly={showValueAndReferenceColumnsOnly}
        />
      )}
      {includesSection(
        BorrowingBaseSummarySections.finalBorrowingBaseReport,
      ) && (
        <BorrowingBaseSummaryFinalBorrowingBaseReport
          borrowingBaseReports={borrowingBaseReports}
          showComparisonAndDifferenceColumns={
            showComparisonAndDifferenceColumns
          }
          showValueAndReferenceColumnsOnly={showValueAndReferenceColumnsOnly}
        />
      )}
    </VStack>
  );
};
